module.exports = __webpack_public_path__ + "static/media/matthew-tan-178x178.e3e27719.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/advisors/images/matthew-tan-178x178.jpg
// module id = 1770
// module chunks = 146